export * from './fake-promise';
export * from './random-generators';
export * from './random-title';
export * from './test-utils';
export * from './ts-utils';
export var isWildcard = function (a) { return a === '*'; };
export var createFakePostResponder = function (fakeHttp, url, fail) { return function (dto) {
    return {
        respond: function (data) {
            if (fail) {
                return fakeHttp.whenPost(url, dto).throw(fail);
            }
            return fakeHttp.whenPost(url, dto).respond(data);
        },
        throw: function (error) {
            return fakeHttp.whenPost(url, dto).throw(error);
        }
    };
}; };
export var createFakePutResponder = function (fakeHttp, url) { return function (dto) {
    return {
        respond: function (data) {
            return fakeHttp.whenPut(url, dto).respond(data);
        },
        throw: function (error) { return fakeHttp.whenPut(url, dto).throw(error); }
    };
}; };
export var createFakeGetResponder = function (fakeHttp, url) {
    return {
        respond: function (data) {
            return fakeHttp.whenGet(url).respond(data);
        },
        throw: function (error) { return fakeHttp.whenGet(url).throw(error); }
    };
};
export var createFakeDeleteResponder = function (fakeHttp, url) {
    return {
        respond: function (data) {
            return fakeHttp.whenDelete(url).respond(data);
        },
        throw: function (error) { return fakeHttp.whenDelete(url).throw(error); }
    };
};
export var isRejected = function (promise) {
    return promise.then(function () { return false; }, function () { return true; });
};
//# sourceMappingURL=index.js.map